import { put, call, takeLatest, take } from 'redux-saga/effects';
import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import { select } from '../../../stores';
import { goto } from '../../../actions/historyActions';
import {
  FETCH_LUCKYDRAW_TOKEN,
  FETCH_LUCKYDRAW_TOKEN_SUCCESS,
  FETCH_LUCKYDRAW_TOKEN_FAILURE,
  redirectToLuckydraw,
  fetchLuckydrawToken as fetchLuckydrawTokenAction,
  REDIRECT_TO_LUCKYDRAW,
} from '../actions/luckydrawActions';
import { DEEPLINK_TO_LUCKYDRAW } from '../actions/deeplinkActions';
import { REDIRECT_ACTION } from '../../partners/actions';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  getLuckydrawTokenUrl,
  getLuckydrawToken,
  getLuckydrawLandingDeeplink,
  getErrorMessageCode,
} from '../selectors/luckydrawSelector';
import { getLanguage } from '../../../selectors/userSelectors';
import { PostMsgParams } from '../../partners/types/partnerTypes';
import {
  setPageLoading,
  setPageNotLoading,
} from '../../myPrivileges/actions/myPrivilegesAction';

function* redirectToXGateLuckydraw(action: any) {
  const deeplink = select(getLuckydrawLandingDeeplink);
  const { host } = deeplink;
  const authToken = select(getLuckydrawToken);

  const postMsgParams: PostMsgParams = {};
  postMsgParams.action = REDIRECT_ACTION;
  if (authToken) {
    postMsgParams.params = {};
    postMsgParams.params.token = authToken;
  }
  yield call(goto, host, undefined, postMsgParams);
}

function* deepLinkToLuckydraw(action: any) {
  try {
    const tokenUrl = select(getLuckydrawTokenUrl);
    goto('emma-my-privileges/direct');
    yield put(fetchLuckydrawTokenAction(tokenUrl));
    yield take(FETCH_LUCKYDRAW_TOKEN_SUCCESS);
    yield put(redirectToLuckydraw());
  } catch (error) {
    console.error(error);
  }
}

function* fetchLuckydrawToken(action: any) {
  const { url, fetchLuckydrawTokenSuccess, fetchLuckydrawTokenFailure } =
    action.payload;
  try {
    if (!url) {
      return;
    }
    yield put(setPageLoading());
    const language = select(getLanguage);
    const languageUpperCase = language ? language.toUpperCase() : '';
    const urlWithParam = url.replace('${language}', languageUpperCase);
    const res = yield call(myAxaFetchWithToken, urlWithParam, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-axahk-msgid': uuidv4(),
      },
    });
    if (res && res.status === 200) {
      const data = yield res.json();
      const token = data.retrieveLuckyDrawResponse.authToken;
      yield put(fetchLuckydrawTokenSuccess(token));
    } else {
      throw res;
    }
  } catch (e) {
    yield put(fetchLuckydrawTokenFailure(e));
  } finally {
    yield put(setPageNotLoading());
  }
}

function* displayError() {
  const errorMessageCode = select(getErrorMessageCode);
  yield goto(`emma-general-error-code?error_code=${errorMessageCode}`);
}

function* luckydrawSaga(): any {
  yield takeLatest(FETCH_LUCKYDRAW_TOKEN, fetchLuckydrawToken);
  yield takeLatest(DEEPLINK_TO_LUCKYDRAW, deepLinkToLuckydraw);
  yield takeLatest(REDIRECT_TO_LUCKYDRAW, redirectToXGateLuckydraw);
  yield takeLatest(FETCH_LUCKYDRAW_TOKEN_FAILURE, displayError);
}

export default luckydrawSaga;
